import React from 'react';

class ChannelMeta extends React.Component {
  
  render () {

    let style = this.props.styles;

    //afbeelding als background-image, gecentreerd en verticaal uitgevuld

    //basis image style style die zowel op channel-logo als artist-image van toepassing is    
    let coverImageStyle = {
      width: '20vw',
      height: '20vw',
    }
    
    //image style aanvullen afhankelijk van channel-logo of artist image
    if (this.props.metaData.metaData?.now?.image) {
      //artist-image
      coverImageStyle = {
        overflow: 'hidden',
        backgroundImage: 'url("' + this.props.metaData.metaData.now?.image.replace('RP_1024_430', 'RP_600x600') + '")',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top center',
        ...coverImageStyle,
      }
    } else if (this.props.metaData.metaData?.program?.image) {
      //program-image
      coverImageStyle = {
        overflow: 'hidden',
        backgroundImage: 'url("' + this.props.metaData.metaData?.program?.image.replace('RP_1024_430', 'RP_600x600') + '")',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top center',
        ...coverImageStyle,
      }
    } else {
      //channel-logo of channel-placeholder
      if (['03','13','32','44','45','56','57','58','110','111','120','121','140','141','142'].indexOf(this.props.channelId) !== -1) {
        coverImageStyle = {
          overflow: 'hidden',
          backgroundImage: 'url("' + this.props.placeholderUrl + '")',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top center',
          ...coverImageStyle,
        }
      } else {
        coverImageStyle = {
          backgroundImage: 'url("' + this.props.logoUrl + '")',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          ...coverImageStyle,
        }
      }
    }

    //if (this.props.metaData.image) {
    if (this.props.metaData.metaData?.now?.image) {
      // In dit geval moet de "channelLogo"-div het volledige vak vullen
      style.backgroundImage = 'url("' + this.props.metaData.metaData.now?.image + '")';
      style.backgroundSize = 'cover';
      style.backgroundRepeat = 'no-repeat';
      style.backgroundAttachment = 'fixed';
      style.backgroundPosition = 'top center';
      style.filter = 'blur(5px)';
      style.opacity = '0.5';
    }

    style.zIndex = '-1';

    let innerDivStyle = {
      zIndex: '0',
      width: '30vw',
      color: 'white'
    }

    let artist = this.props.metaData.metaData?.now?.artist;
    if (artist && (this.props.channelCode.charAt(0) === '3')) {
      artist = 'Uitvoerder: ' + artist;
    }

    let programName = '';
    let presenterName = '';
    if (['03','13','32','44','45','56','57','58','110','111','120','121','140','141','142'].indexOf(this.props.channelId) === -1) {
      programName = this.props.metaData.metaData?.program?.title;
      presenterName = this.props.metaData?.metaData?.program?.presenters;
    }

    return ( 
              <div className="metaContainer" style={innerDivStyle}>
                <div className="metaArtistImage" style={coverImageStyle}>
                  
                </div>
                <div className="song-info">
                  <div className="title">
            {artist ? this.props.metaData.metaData.now?.title : programName}
                  </div>
                  <div className="artist">
                    {artist ? artist : presenterName}  
                  </div>
                </div>
              </div> 
          );
  }

}

export default ChannelMeta;